import { sumBy } from "lodash";

import { type OrderItemDetailsSandboxItemSandboxItemVersionReadDto } from "@/config/apiClient";

export const getSandboxItemQuantity = (
  sandboxItemVersions: Array<
    Omit<OrderItemDetailsSandboxItemSandboxItemVersionReadDto, "file">
  >
) =>
  sumBy(sandboxItemVersions, (version) =>
    sumBy(version.SandboxItemVersionDispatch, "quantity")
  );
